import {
  SidePanelDS,
  Spacer,
  TableTagHomeChargingConnectionStatus,
  TextCapitalized,
  dateFormatterDayMonthYear,
} from "@qivia/ui";
import { colors } from "@qivia/ui/src/styles/figmaColors";
import { typographies } from "@qivia/ui/src/styles/figmaTypographies";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { ElectricVehicleApi } from "../../electricVehiclesAPI";
import "../../../../../i18n/i18n";

export const ElectricVehicleDetails = (props: {
  electricVehicle: ElectricVehicleApi;
}) => {
  const { t } = useTranslation();
  const { electricVehicle } = props;

  return (
    <>
      <SectionTitle>
        <TextCapitalized>
          {t("electric_vehicles.sidePanel.detail.title")}
        </TextCapitalized>
      </SectionTitle>
      <Spacer y={2} />
      <SidePanelDS.SectionRow
        label={
          <SectionRowLabel>
            <TextCapitalized>
              {t("electric_vehicles.sidePanel.detail.status")}
            </TextCapitalized>
          </SectionRowLabel>
        }
        value={
          <TableTagHomeChargingConnectionStatus
            status={t(
              `home_charging.connectionStatus.${electricVehicle.status}`,
            )}
          />
        }
      />
      <Spacer y={2} />
      <SidePanelDS.SectionRow
        label={
          <SectionRowLabel>
            <TextCapitalized>
              {t("electric_vehicles.sidePanel.detail.batteryCapacity")}
            </TextCapitalized>
          </SectionRowLabel>
        }
        value={
          electricVehicle.batteryCapacity !== null
            ? `${electricVehicle.batteryCapacity} kWh`
            : "-"
        }
      />
      <Spacer y={2} />
      <SidePanelDS.SectionRow
        label={
          <SectionRowLabel>
            <TextCapitalized>
              {t("electric_vehicles.sidePanel.detail.createdAt")}
            </TextCapitalized>
          </SectionRowLabel>
        }
        value={dateFormatterDayMonthYear(new Date(electricVehicle.createdAt))}
      />
      <Spacer y={2} />
      <SidePanelDS.SectionRow
        label={
          <SectionRowLabel>
            <TextCapitalized>
              {t("electric_vehicles.sidePanel.detail.driverName")}
            </TextCapitalized>
          </SectionRowLabel>
        }
        value={"-"}
      />
    </>
  );
};

const SectionTitle = styled.div`
  ${typographies["Body/L"]}
  color: ${colors["colors/text/darkGrey"]}
`;

const SectionRowLabel = styled.div`
  ${typographies["Body/L"]}
  color: ${colors["colors/text/black"]}
`;
